'use client';

import { useEffect, useState } from 'react';
import { networkService } from '@/server/networkService';

export function useNetworkActivity() {
  const [history, setHistory] = useState<number[]>([]);
  const [currentSpeed, setCurrentSpeed] = useState(0);

  useEffect(() => {
    const unsubscribe = networkService.subscribe((newHistory, speed) => {
      setHistory(newHistory);
      setCurrentSpeed(speed);
    });

    return unsubscribe;
  }, []);

  return { history, currentSpeed };
}
